import logo from "./logo.svg";
import "./App.css";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Footer from "./components/Footer";
import { HashRouter, Routes, Route } from "react-router-dom";
import AboutUs from "./components/AboutUs";
import Inventory from "./components/Inventory";
import PartnerWithUs from "./components/PartnerWithUs";
import Accounting from "./Accounting";
import Invoicing from "./Invoicing";
import EInvoicing from "./EInvoicing";
import EWayBill from "./EWaybill";
import TransportManagement from "./TransportManagement";
import APMCCommissionAgent from "./APMCCommissionAgent";
import PricingPlans from "./components/PricingPlans";
import ScrollToTop from "./components/ScrollToTop";
import PrivacyPolicy from "./components/Policies/PrivacyPolicy";
import TermsOfService from "./components/Policies/TermsOfService";
import CookiePolicy from "./components/Policies/CookiePolicy";
import ContactUs from "./components/ContactUs";
import { ToastContainer, Zoom } from "react-toastify";

function App() {
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={4000}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        transition={Zoom}
        toastStyle={{ backgroundColor: "#ffffff", color: "#000000" }}
      />
      <HashRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" exact element={<Home />}></Route>
          <Route path="/about" exact element={<AboutUs />}></Route>
          <Route path="/partner" exact element={<PartnerWithUs />}></Route>
          <Route path="/Inventory" exact element={<Inventory />}></Route>
          <Route path="/Accounting" exact element={<Accounting />}></Route>
          <Route path="/Invoicing" exact element={<Invoicing />}></Route>
          <Route path="/E-Invoice" exact element={<EInvoicing />}></Route>
          <Route path="/E-WayBill" exact element={<EWayBill />}></Route>
          <Route path="/PricingPlans" exact element={<PricingPlans />}></Route>
          <Route
            path="/Transport"
            exact
            element={<TransportManagement />}
          ></Route>
          <Route
            path="/APMCCommissionAgent"
            exact
            element={<APMCCommissionAgent />}
          ></Route>
          <Route path="/privacy-policy" exact element={<PrivacyPolicy />}></Route>
          <Route path="/terms-of-service" exact element={<TermsOfService />}></Route>
          <Route path="/cookie-policy" exact element={<CookiePolicy />}></Route>
          <Route path="/contact" exact element={<ContactUs />}></Route>
        </Routes>
        <Footer />
      </HashRouter>
    </>
  );
}

export default App;
